import $$ from 'cmn-utils'

const baseUrl = "/api/sys/system-notice/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
}